/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClassPendingEnrollmentRequest
 */
export interface ClassPendingEnrollmentRequest {
    /**
     * 
     * @type {string}
     * @memberof ClassPendingEnrollmentRequest
     */
    classId: string;
}

/**
 * Check if a given object implements the ClassPendingEnrollmentRequest interface.
 */
export function instanceOfClassPendingEnrollmentRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "classId" in value;

    return isInstance;
}

export function ClassPendingEnrollmentRequestFromJSON(json: any): ClassPendingEnrollmentRequest {
    return ClassPendingEnrollmentRequestFromJSONTyped(json, false);
}

export function ClassPendingEnrollmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassPendingEnrollmentRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'classId': json['classId'],
    };
}

export function ClassPendingEnrollmentRequestToJSON(value?: ClassPendingEnrollmentRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'classId': value.classId,
    };
}

